export default __webpack_public_path__ + "static/media/visualization.070ae5b0.webp";